<div class="editable" [class.editing]="editing" style="width:100%">
  <span class="editable-span" (click)="editing=true">
    {{text}}
  </span>
  <span *ngIf="!text||text.length==0"  style ="color:#ccc" class="editable-span" (click)="editing=true">
    {{defaultText}}
  </span>
  <div class="input-wrapper">
    <input type="text" autocomplete="false" minlength="20" [appFocus]="editing" [(ngModel)]="editStr" (blur)="onBlur($event)" (focus)="onFocus()"/>
  </div>
  <!--<div *ngIf="editing&&figureno" class="input-wrapper">
    <input type="text" autocomplete="false" [appFocus]="editing" [(ngModel)]="editStr" maxlength="2" (blur)="onBlur($event)" pattern="[0-9]{1}" />
  </div>
  <div *ngIf="editing&&titleInput" class="input-wrapper">
    <input type="text" autocomplete="false" [appFocus]="editing" [(ngModel)]="editStr" (keypress)="nameValidate($event)" (blur)="onBlur($event)" pattern="[0-9]{1}" />
  </div>-->
  <i class="fas fa-pen" (click)="editing=true"></i>
</div>
